import { FromMachineActionBase } from '../from-machine-action.base';
import {
  BookingParams,
  BookingPosition,
  BookingResult,
  StockTargetType,
} from '../../types';

/**
 * Maschinen-Quelle in der BufferstockOnly-Welt. Einzige gültige Richtung ist
 * die Verschrottung Maschine → BufferstockDisposal; die Rücknahme wird beim
 * Befüllen in die OrderMovement verrechnet.
 */
export class BufferstockOnlyFromMachineAction extends FromMachineActionBase {
  /**
   * Routet die Buchung nach `targetType`; einzig M→BufferstockDisposal ist
   * gültig, alle anderen Ziele werden abgelehnt.
   *
   * @param position Zu buchende Position (article_id und amount)
   * @param params Buchungskontext, Adapter und stabile client_ids
   * @returns BookingResult der Verschrottung bzw. Fehler bei unzulässigem Ziel
   */
  public async execute(
    position: BookingPosition,
    params: BookingParams,
  ): Promise<BookingResult> {
    this.debugInfo('[from-machine:bufferstock-only]', position, params);
    switch (params.context.booking.targetType) {
      case StockTargetType.BUFFERSTOCK_DISPOSAL:
        return this.toBufferstockDisposal(position, params);
      case StockTargetType.CAR:
        return this.failure(
          'Maschine → KFZ ist in der BufferstockOnly-Welt nicht verfügbar',
        );
      case StockTargetType.BUFFERSTOCK:
        return this.failure(
          'Maschine → Bufferstock ist keine valide Direction (Rücknahme wird beim Befüllen verrechnet)',
        );
      case StockTargetType.MACHINE:
        return this.failure('Maschine → Maschine ist keine valide Direction');
      case StockTargetType.TRASH_BIN:
        return this.failure('Maschine → Müll ist keine valide Direction');
      case StockTargetType.CONSUMPTION_BIN:
        return this.failure('Maschine → Verbrauch ist keine valide Direction');
      default:
        return this.exhaustiveFailure(params.context.booking.targetType);
    }
  }
}
